const themes = {
    hrlm: {
        logoFontFamily: "Pricedown-Bl",
        titleFontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
        defaultFontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
    },
    nizza: {
        logoFontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
        titleFontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
        defaultFontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
    }
}

// Tax profiles define the tax components and categories applicable per jurisdiction.
// Each profile specifies the default tax behavior (inclusive/exclusive pricing),
// the tax components that apply, and the categories used to classify items.
// fiscalMapping maps tax categories to fiscal printer tax group codes where applicable.
const taxProfiles = {
    BG_VAT: {
        name: 'Bulgarian VAT',
        type: 'VAT',
        country: 'BG',
        region: null,
        priceIncludesTax: true,
        components: [
            { type: 'VAT', label: 'VAT', jurisdiction: 'BG' },
        ],
        categories: [
            { code: 'standard', label: 'Standard (20%)', rates: { VAT: 20 } },
            { code: 'reduced', label: 'Reduced (9%)', rates: { VAT: 9 } },
            { code: 'zero', label: 'Zero (0%)', rates: { VAT: 0 } },
            { code: 'exempt', label: 'Exempt', rates: { VAT: 0 } },
        ],
        fiscalMapping: { VAT: { standard: 2, reduced: 2, zero: 2, exempt: 2 } },
    },
    US_CA: {
        name: 'California',
        type: 'SALES_TAX',
        country: 'US',
        region: 'CA',
        priceIncludesTax: false,
        components: [
            { type: 'STATE_SALES', label: 'CA State Tax', jurisdiction: 'US-CA' },
        ],
        categories: [
            { code: 'standard', label: 'Taxable (7.25%)', rates: { STATE_SALES: 7.25 } },
            { code: 'exempt', label: 'Tax Exempt', rates: { STATE_SALES: 0 } },
        ],
        fiscalMapping: null,
    },
};

// Helper: build a flat list of picker-friendly categories from a tax profile
// Returns array of { label, code, rates, combinedRate } for use in UI pickers
function buildTaxCategories(profile) {
    if (!profile || !profile.categories) return [];
    return profile.categories.map(cat => ({
        label: cat.label,
        value: cat.code,
        rates: cat.rates,
        combinedRate: Object.values(cat.rates).reduce((sum, r) => sum + (r || 0), 0),
    }));
}

// Helper: build the default taxes array for a line item given a category code
// Returns array of { type, label, rate, category, jurisdiction, amount: 0 }
function buildTaxesFromCategory(profile, categoryCode) {
    if (!profile || !profile.categories || !profile.components) return [];
    const cat = profile.categories.find(c => c.code === categoryCode);
    if (!cat) return [];
    return profile.components.map(comp => ({
        type: comp.type,
        label: comp.label,
        rate: cat.rates[comp.type] != null ? cat.rates[comp.type] : 0,
        category: categoryCode,
        jurisdiction: comp.jurisdiction,
        amount: 0,
    }));
}

const refractionXLegal = {
    companyName: "REFRACTION X",
    taxId: "206831562",
    taxIdLabel: "EIK / TIN",
    address: "21 Lavski Rid str., 1680 Sofia, Bulgaria",
    country: "Bulgaria",
    email: "info@refractionx.com",
    phone: "+359 879 354 961",
    serviceCity: "Sofia",
    deliveryMinimum: "10 EUR",
    pickupForfeitureWindow: "30 minutes",
    prepTime: "15–30 minutes",
    deliveryTime: "20–60 minutes",
    governingLaw: "Republic of Bulgaria",
    consumerAuthority: {
        name: "Bulgarian Consumer Protection Commission (Комисия за защита на потребителите)",
        url: "https://kzp.bg/",
    },
    odrUrl: "https://ec.europa.eu/consumers/odr/",
};

const config = {
    hrlm: {
        brandName: "Harlem",
        brandTitle: "Harlem & Littaly",
        landingEyebrow: "Food, drinks, gaming",
        landingTagline: "Order from the bar, check the menu, or jump into the venue app.",
        defaultLanguage: "bg",
        menuTitle: "Harlem Menu",
        orderBrand: "HRLM & Littaly",
        companyColor: 'red',
        invitationMessage: `You're invited to join HRLM @ REFRACTION X`,
        dateFormat: 'DMY', // DD/MM/YYYY (European)
        taxProfile: taxProfiles.BG_VAT,
        legal: { ...refractionXLegal, tradingAs: "Harlem & Littaly" },
        modules: {
            vr: true,
            esports: true,
            menu: true,
            benefits: true,
            delivery: true,
            onlineOrdering: true,
        }
    },
    nizza: {
        brandName: "Burger Nizza",
        brandTitle: "Burger Nizza",
        landingEyebrow: "Burgers, sides, delivery",
        landingTagline: "Order online, check the menu, or choose pickup and delivery.",
        menuTitle: "Burger Nizza Menu",
        orderBrand: "Burger Nizza",
        companyColor: '#c00a25',
        invitationMessage: `You're invited to join NIZZA @ THE VENUE`,
        dateFormat: 'DMY', // DD/MM/YYYY (European)
        taxProfile: taxProfiles.BG_VAT,
        legal: { ...refractionXLegal, tradingAs: "Burger Nizza" },
        modules: {
            vr: false,
            esports: false,
            menu: true,
            benefits: false,
            delivery: true,
            onlineOrdering: true,
        }
    }
}

export { taxProfiles, buildTaxCategories, buildTaxesFromCategory };

export default {
    theme: themes[process.env.EXPO_PUBLIC_THEME],
    ...config[process.env.EXPO_PUBLIC_THEME]
}
